var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 30,
    viewBox: "0 0 60 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.875C34.075 16.875 37.675 17.85 40.6 19.125C43.3 20.325 45 23.025 45 25.95V30H15V25.975C15 23.025 16.7 20.325 19.4 19.15C22.325 17.85 25.925 16.875 30 16.875ZM10 17.5C12.75 17.5 15 15.25 15 12.5C15 9.75 12.75 7.5 10 7.5C7.25 7.5 5 9.75 5 12.5C5 15.25 7.25 17.5 10 17.5ZM12.825 20.25C11.9 20.1 10.975 20 10 20C7.525 20 5.175 20.525 3.05 21.45C1.2 22.25 0 24.05 0 26.075V30H11.25V25.975C11.25 23.9 11.825 21.95 12.825 20.25ZM50 17.5C52.75 17.5 55 15.25 55 12.5C55 9.75 52.75 7.5 50 7.5C47.25 7.5 45 9.75 45 12.5C45 15.25 47.25 17.5 50 17.5ZM60 26.075C60 24.05 58.8 22.25 56.95 21.45C54.825 20.525 52.475 20 50 20C49.025 20 48.1 20.1 47.175 20.25C48.175 21.95 48.75 23.9 48.75 25.975V30H60V26.075ZM30 0C34.15 0 37.5 3.35 37.5 7.5C37.5 11.65 34.15 15 30 15C25.85 15 22.5 11.65 22.5 7.5C22.5 3.35 25.85 0 30 0Z",
    fill: "url(#paint0_linear_9_2240)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2240",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3086FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon2);
export default __webpack_public_path__ + "static/media/userIcon2.5a2b7c4aac9b05163ce67da22c0a9ad9.svg";
export { ForwardRef as ReactComponent };